/* Heads Up Hockey — Shooting Trainer page behaviour (Shopify port)
   Combines the two inline scripts from shooting-trainer.html:
   1) the app-tab video switcher
   2) the scroll-triggered shot-analysis count-up + hit-ring fill
   Loaded with `defer`, so the DOM is ready when these IIFEs run.
   The prototype's nav/footer injector (site.js) is intentionally NOT
   ported — the Shopify theme renders the header & footer. */

/* App tab switcher: each tab plays its clip; the phone advances when the clip ends.
   Click a tab to jump. A stall-safety timer keeps it moving if a clip can't play. */
(function () {
  var btns  = document.querySelectorAll('.tab-btn');
  var media = document.querySelectorAll('.tab-media');
  if (!btns.length) return;
  var order = ['train', 'coach', 'compete', 'progress'];
  var SLOW = 0.5;            // tab clip playback speed (1 = normal, 0.5 = half)
  var i = 0, fallback;
  function show(tab) {
    i = order.indexOf(tab);
    btns.forEach(function (b) { b.classList.toggle('active', b.dataset.tab === tab); });
    media.forEach(function (m) {
      var on = m.dataset.tab === tab;
      m.classList.toggle('active', on);
      if (m.tagName === 'VIDEO') {
        if (on) { try { m.currentTime = 0; m.playbackRate = SLOW; var p = m.play(); if (p && p.catch) p.catch(function(){}); } catch (e) {} }
        else { try { m.pause(); } catch (e) {} }
      }
    });
    clearTimeout(fallback);
    fallback = setTimeout(next, 60000); // safety only — clips normally advance on 'ended'
  }
  function next() { show(order[(i + 1) % order.length]); }
  media.forEach(function (m) {
    if (m.tagName === 'VIDEO') m.addEventListener('ended', function () { if (m.classList.contains('active')) next(); });
  });
  btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.tab); }); });
  show('train');
})();

/* Count the shot-analysis stats up + fill the hit-ring when the section scrolls into view */
(function () {
  var sec = document.getElementById('below');
  if (!sec) return;
  function ease(p){ return 1 - Math.pow(1 - p, 3); }
  function countEl(el){
    var m = (el.textContent || '').trim().match(/^(\d+)(.*)$/); if(!m) return;
    var target = parseInt(m[1],10), suffix = m[2], dur = 900, s = null;
    function step(t){ if(!s) s=t; var p=Math.min((t-s)/dur,1); el.textContent = Math.round(ease(p)*target)+suffix; if(p<1) requestAnimationFrame(step); }
    el.textContent = '0'+suffix; requestAnimationFrame(step);
  }
  var done = false;
  function run(){
    if(done) return; done = true;
    sec.querySelectorAll('.app-strip .n, .hit-ring .num, .every-shot .es-h .avg b').forEach(countEl);
    var ring = sec.querySelector('.hit-ring');
    if(ring){ var s=null; (function go(){ ring.style.setProperty('--hit','0%'); requestAnimationFrame(function r(t){ if(!s)s=t; var p=Math.min((t-s)/900,1); ring.style.setProperty('--hit', Math.round(ease(p)*50)+'%'); if(p<1) requestAnimationFrame(r); }); })(); }
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) run(); }); }, {threshold:0.35}).observe(sec);
  } else { run(); }
})();
